<script setup lang="ts">
    import KFormFieldDisplay from "@/components/forms/displays/FormFieldDisplay/KFormFieldDisplay.vue";
    import { calculateBMI } from "@/components/forms/reusables/BMIHelper";
    import { replaceSeparator } from "@/components/forms/inputs/Number/numberUtils";
    import { computed, ref } from "vue";

    const vikt = ref<number>(0);
    const langd = ref<number>(0);

    const bmi = computed(() => calculateBMI(langd.value, vikt.value));

    /**
     * Fälten är KNumber, som visar decimaler med komma och därför också har komma i formulärets värde, medan
     * backend skickar dem med punkt. Båda formerna måste bli ett tal här, annars väntar BMI:t på att formuläret
     * sparas i stället för att räknas ut medan vikten matas in. Samma normalisering som news2 gör i toNumber.
     */
    const toNumber = (value?: string | number) => {
        const number = Number(replaceSeparator({ value, toComma: false }));

        return isNaN(number) ? 0 : number;
    };

    defineExpose({
        formListeners: [
            {
                fieldNames: ["langd", "vikt"],
                runAtInitial: true,
                action: ({ values }: { values: { vikt: string | number; langd: string | number } }) => {
                    vikt.value = values.vikt ? toNumber(values.vikt) : 0;
                    langd.value = values.langd ? toNumber(values.langd) : 0;
                },
            },
        ],
    });
</script>

<template>
    <KFormFieldDisplay name="bmi" label="BMI" :value="bmi" :showEmptyValue="true" />
</template>

<style lang="scss" scoped></style>
